import { render, staticRenderFns } from "./NormalDocument.vue?vue&type=template&id=8b7e957e&scoped=true&"
import script from "./NormalDocument.vue?vue&type=script&lang=js&"
export * from "./NormalDocument.vue?vue&type=script&lang=js&"
import style0 from "./NormalDocument.vue?vue&type=style&index=0&id=8b7e957e&prod&lang=scss&scoped=true&"
import style1 from "./NormalDocument.vue?vue&type=style&index=1&id=8b7e957e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7e957e",
  null
  
)

export default component.exports